<template>
    <div>
        <!-- Actions -->
        <div class="actions float-right" v-if="feedback.type != 'mark'">

            <badge type="secondary" style="font-size:1.2rem;" v-if="edit">
                <a href="#" class="text-danger mr-2" @click.prevent="$emit('remove', feedback)">
                    <i class="tim-icons icon-simple-remove"></i>
                </a>
                <a href="#" class="text-primary" @click.prevent="$emit('update', feedback)">
                    <i class="tim-icons icon-pencil"></i>
                </a>
            </badge>
        </div>

        <!-- Note -->
        <!-- Keep it one 1 line -->
        <p class="description" v-if="feedback.type == 'note'">{{ feedback.description }}</p>

        <!-- Picture -->
        <div v-if="feedback.type == 'picture'">
            <clickable-image :src="feedback.file_src"></clickable-image>
            <p class="description mt-2">{{ feedback.description }}</p>
        </div>

        <!-- Mark -->
        <base-dropdown v-if="edit && feedback.type == 'mark'">
            <base-button slot="title-container" type="warning" class="dropdown-toggle">
                <i class="fas fa-map-marker-alt mr-1"></i> {{ $t('feedbacks.mark') }}
            </base-button>
            <a class="dropdown-item" href="#" @click.prevent="$emit('createNote')">
                {{ $t('feedbacks.take-note') }}
            </a>
            <a class="dropdown-item" href="#" @click.prevent="$emit('createPicture')">
                {{ $t('feedbacks.insert-picture') }}
            </a>
            <a class="dropdown-item" href="#" @click.prevent="$emit('createIssue')">
                {{ $t('issues.add-issue') }}
            </a>
            <a class="dropdown-item" href="#" @click.prevent="$emit('remove', feedback)">
                {{ $t('feedbacks.remove-mark') }}
            </a>
        </base-dropdown>

        <!-- Author -->
        <small class="d-block mt-3 text-primary" v-if="feedback.tester && showAuthor">
            <em>-- {{ feedback.tester.name }}</em>
        </small>
    </div>
</template>

<script>
    export default {

        props: {

            feedback: {
                type: Object,
                required: true
            },

            edit: {
                type: Boolean,
                default: false
            },

            showAuthor: {
                type: Boolean,
                default: false
            },            
        },
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
    }
    .actions >>> .btn-group-toggle {
        display: inline-block;
        margin-right: 8px;
        position: relative;
        top: -5px;
    }
    .actions >>> .btn-group-toggle label {
        padding: 0.45rem 0.375rem 0.45rem 0;
        font-size: 0.7rem;
        text-transform: uppercase;
    }
    .recipients {
        font-size: 80%;
        list-style-type: none;
        padding-left: 10px;
        margin-bottom: 0;
        border-left: dashed 1px #7182e4
    }

</style>
